/**
 * 产品详情页：若 URL 带 color 参数，自动激活匹配的颜色选项（ymq-shopify-option-box）
 * 匹配规则：不区分大小写，option value 可为 "Gardenia (#7084-7)" 形式，与 param 的 color 比对
 */
function initProductPageColorFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const colorParam = params.get("color");
  if (!colorParam || !colorParam.trim()) return;

  const box = document.querySelector(".ymq-shopify-option-box");
  if (!box) return;

  const normalizedParam = colorParam.trim().toLowerCase();
  const colorInputs = box.querySelectorAll(
    'input.ymq-shopify-option[name^="Color"], input.ymq-shopify-option[name^="colour"]',
  );

  for (const input of colorInputs) {
    if (input.getAttribute("ymq-option-disabled") === "true") continue;
    const value = (input.getAttribute("value") || "").trim();
    const normalizedValue = value.toLowerCase();
    const match =
      normalizedValue === normalizedParam ||
      normalizedValue.startsWith(normalizedParam + " ") ||
      normalizedValue.startsWith(normalizedParam + "(");
    if (match) {
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      const label = input.closest("label");
      if (label) label.click();
      break;
    }
  }
}

/**
 * 手机端 Color 选项：仅在商品详情 .product-single__meta 下追加「Expand Colors」按钮，点击在 grid 与横向滑动布局间切换
 */
function initColorExpandToggle() {
  var boxes = document.querySelectorAll(
    '.product-single__meta .ymq-options-box[ymq-option-label="Color"]',
  );
  for (var i = 0; i < boxes.length; i++) {
    var box = boxes[i];
    if (box.querySelector(".ymq-color-expand-toggle")) continue;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ymq-color-expand-toggle";
    btn.textContent = "Expand Colors";
    btn.setAttribute("aria-expanded", "false");

    (function (b, btnEl) {
      btnEl.addEventListener("click", function () {
        var expanded = b.classList.toggle("ymq-color-expanded");
        btnEl.textContent = expanded ? "Collapse" : "Expand Colors";
        btnEl.setAttribute("aria-expanded", String(expanded));
      });
    })(box, btn);

    box.appendChild(btn);
  }
}

/** 监听 DOM 变化 + 轮询，在 YMQ 动态插入 Color 区域后挂载 Expand 按钮 */
function observeColorBoxAndInitToggle() {
  initColorExpandToggle();

  var colorBoxSel = '.ymq-options-box[ymq-option-label="Color"]';
  var observer = new MutationObserver(function (mutations) {
    var run = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(colorBoxSel)) {
          run = true;
          break;
        }
        if (node.querySelector && node.querySelector(colorBoxSel)) {
          run = true;
          break;
        }
      }
      if (run) break;
    }
    if (run) initColorExpandToggle();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  var delays = [400, 1000, 2000, 4000, 6000];
  for (var d = 0; d < delays.length; d++) {
    (function (delay) {
      setTimeout(initColorExpandToggle, delay);
    })(delays[d]);
  }
}

var sliverCollectionGridStorageKey = "sliverCollectionMobileGridColumns";

function sliverReadCollectionGridColumns() {
  try {
    var storedColumns = window.localStorage.getItem(
      sliverCollectionGridStorageKey,
    );
    return storedColumns === "1" ? "1" : "2";
  } catch (error) {
    return "2";
  }
}

function sliverWriteCollectionGridColumns(columns) {
  try {
    window.localStorage.setItem(sliverCollectionGridStorageKey, columns);
  } catch (error) {
    // Ignore private browsing or blocked storage; the current click still works.
  }
}

function sliverFindCollectionGridWrapper(element) {
  if (!element) return null;

  var wrapper = element.closest(".collection-grid__wrapper");
  if (wrapper) return wrapper;

  var section = element.closest(".main-collection-filter");
  if (!section) return null;

  return section.querySelector(".collection-grid__wrapper");
}

function sliverSetCollectionGridView(wrapper, columns, shouldPersist) {
  if (!wrapper) return;

  var isOneColumn = columns === "1";
  var section = wrapper.closest(".main-collection-filter") || wrapper;
  var buttons = section.querySelectorAll(
    "[data-sliver-collection-view-toggle]",
  );

  wrapper.classList.toggle("sliver-collection-grid--one-column", isOneColumn);
  wrapper.classList.toggle("sliver-collection-grid--two-column", !isOneColumn);
  wrapper.setAttribute("data-sliver-collection-grid-columns", columns);

  for (var i = 0; i < buttons.length; i++) {
    var button = buttons[i];
    button.classList.toggle("is-one-column", isOneColumn);
    button.setAttribute("aria-pressed", String(isOneColumn));
    button.setAttribute(
      "aria-label",
      isOneColumn ? "Switch to two columns" : "Switch to one column",
    );
  }

  if (shouldPersist) {
    sliverWriteCollectionGridColumns(columns);
  }
}

function initSliverCollectionGridToggle() {
  var buttons = document.querySelectorAll(
    "[data-sliver-collection-view-toggle]",
  );
  var columns = sliverReadCollectionGridColumns();
  var initializedWrappers = [];

  for (var i = 0; i < buttons.length; i++) {
    var wrapper = sliverFindCollectionGridWrapper(buttons[i]);
    if (!wrapper || initializedWrappers.indexOf(wrapper) !== -1) continue;
    initializedWrappers.push(wrapper);
    sliverSetCollectionGridView(wrapper, columns, false);
  }
}

function observeSliverCollectionGridToggle() {
  initSliverCollectionGridToggle();

  var observer = new MutationObserver(function (mutations) {
    var shouldInit = false;

    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          (node.matches &&
            node.matches("[data-sliver-collection-view-toggle]")) ||
          (node.querySelector &&
            node.querySelector("[data-sliver-collection-view-toggle]"))
        ) {
          shouldInit = true;
          break;
        }
      }
      if (shouldInit) break;
    }

    if (shouldInit) initSliverCollectionGridToggle();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener("click", function (event) {
  var button = event.target.closest("[data-sliver-collection-view-toggle]");
  if (!button) return;

  var wrapper = sliverFindCollectionGridWrapper(button);
  if (!wrapper) return;

  var currentColumns =
    wrapper.getAttribute("data-sliver-collection-grid-columns") ||
    sliverReadCollectionGridColumns();
  var nextColumns = currentColumns === "1" ? "2" : "1";

  sliverSetCollectionGridView(wrapper, nextColumns, true);
});

document.addEventListener("DOMContentLoaded", function () {
  MicroModal.init();
  if (document.querySelector(".ymq-shopify-option-box")) {
    initProductPageColorFromUrl();
    setTimeout(initProductPageColorFromUrl, 400);
  }
  observeColorBoxAndInitToggle();
  observeSliverCollectionGridToggle();
  setTimeout(initColorExpandToggle, 800);
  setTimeout(initColorExpandToggle, 2000);
  document.addEventListener("click", function (event) {
    const label = event.target.closest(".bcpo-front-image-label");
    if (!label) return;
    const rect = label.getBoundingClientRect();
    const isAfter =
      event.clientX > rect.right - 20 && event.clientY > rect.bottom - 20;
    if (!isAfter) return;
    event.stopPropagation();
    const input = document.getElementById(label.getAttribute("for"));
    if (!input) return;
    const inputName = input.getAttribute("name");
    const inputValue = input.getAttribute("value");
    const extractedName = inputName.match(/\[(.*?)\]/)?.[1] || inputName;
    const backgroundImage = label.style.backgroundImage;
    const imageUrl = backgroundImage.replace(/^url\(['"](.+)['"]\)$/, "$1");
    const modalTitle = document.getElementById("product-img-modal-title");
    if (modalTitle) {
      modalTitle.innerHTML = extractedName + ": " + inputValue;
    }
    const modalImg = document.getElementById("product-img-modal-img");
    if (modalImg) {
      modalImg.src = imageUrl;
    }
    MicroModal.show("product-img-modal");
  });
  // thumb click scroll to main image
  const thumbItems = document.querySelectorAll(
    ".product__photos--bottom_grid .product__thumb-item",
  );
  const mainImage = document.querySelector(".product-image-main");

  // only add event listener when thumb items and main image exist
  /*
  if (thumbItems.length > 0 && mainImage) {
    thumbItems.forEach(function (thumbItem) {
      thumbItem.addEventListener("click", function (event) {
        // smooth scroll to main image
        mainImage.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
    });
  }
  */
});

/**
 * 初始化购物车删除功能
 * 使用 AJAX 方式删除商品，避免直接跳转导致的错误
 */
function initCartRemoveHandlers() {
  // 使用事件委托处理所有删除链接
  document.addEventListener("click", function (event) {
    const removeLink = event.target.closest("[data-cart-remove]");
    if (!removeLink) return;

    event.preventDefault();
    event.stopPropagation();

    const itemKey = removeLink.getAttribute("data-item-key");
    if (!itemKey) {
      console.error("Cart remove: missing item key");
      return;
    }

    // 显示加载状态
    const originalText = removeLink.textContent.trim();
    removeLink.style.pointerEvents = "none";
    removeLink.textContent = "Removing...";

    // 使用 theme.cart.changeItem API 删除商品
    if (typeof theme !== "undefined" && theme.cart && theme.cart.changeItem) {
      theme.cart
        .changeItem(itemKey, 0)
        .then(function (response) {
          try {
            const cart = JSON.parse(response);

            // 检查是否有错误
            if (cart.status === 422) {
              alert(cart.message || "Failed to remove item from cart");
              removeLink.textContent = originalText;
              removeLink.style.pointerEvents = "";
              return;
            }

            // 触发购物车更新事件
            document.dispatchEvent(new CustomEvent("cart:build"));
            document.dispatchEvent(
              new CustomEvent("cart:updated", {
                detail: { cart: cart },
              }),
            );

            // 如果购物车为空，刷新页面
            if (cart.item_count === 0) {
              window.location.reload();
            } else {
              // 重新加载购物车页面内容
              if (document.getElementById("CartPageForm")) {
                window.location.reload();
              }
            }
          } catch (e) {
            console.error("Cart remove error:", e);
            // 如果解析失败，刷新页面
            window.location.reload();
          }
        })
        .catch(function (error) {
          console.error("Cart remove error:", error);
          alert("Failed to remove item from cart. Please try again.");
          removeLink.textContent = originalText;
          removeLink.style.pointerEvents = "";
        });
    } else {
      // 如果 theme.cart 不可用，使用 fetch API
      fetch(window.Shopify?.routes?.root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0,
        }),
      })
        .then((response) => response.json())
        .then((cart) => {
          if (cart.status === 422) {
            alert(cart.message || "Failed to remove item from cart");
            removeLink.textContent = originalText;
            removeLink.style.pointerEvents = "";
            return;
          }

          document.dispatchEvent(new CustomEvent("cart:build"));
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: { cart: cart },
            }),
          );

          if (cart.item_count === 0) {
            window.location.reload();
          } else {
            window.location.reload();
          }
        })
        .catch((error) => {
          console.error("Cart remove error:", error);
          alert("Failed to remove item from cart. Please try again.");
          removeLink.textContent = originalText;
          removeLink.style.pointerEvents = "";
        });
    }
  });
}

/**
 * 初始化一键清除购物车功能
 */
function initCartClearAll() {
  const clearAllBtn = document.getElementById("cart-clear-all");
  if (!clearAllBtn) return;

  clearAllBtn.addEventListener("click", function (event) {
    event.preventDefault();

    // 确认对话框
    if (!confirm("Are you sure you want to clear all items from your cart?")) {
      return;
    }

    // 显示加载状态
    const originalText = clearAllBtn.textContent;
    clearAllBtn.disabled = true;
    clearAllBtn.textContent = "Clearing...";

    // 获取购物车中的所有商品
    const cartItems = document.querySelectorAll("[data-key]");
    const itemKeys = Array.from(cartItems)
      .map((item) => item.getAttribute("data-key"))
      .filter(Boolean);

    if (itemKeys.length === 0) {
      clearAllBtn.disabled = false;
      clearAllBtn.textContent = originalText;
      return;
    }

    // 批量删除所有商品
    const deletePromises = itemKeys.map((key) => {
      if (typeof theme !== "undefined" && theme.cart && theme.cart.changeItem) {
        return theme.cart.changeItem(key, 0);
      } else {
        // 使用 fetch API
        return fetch(window.Shopify?.routes?.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: key,
            quantity: 0,
          }),
        }).then((response) => response.json());
      }
    });

    // 等待所有删除操作完成
    Promise.all(deletePromises)
      .then(function (responses) {
        // 检查是否有错误
        const hasError = responses.some((response) => {
          try {
            const cart =
              typeof response === "string" ? JSON.parse(response) : response;
            return cart.status === 422;
          } catch (e) {
            return false;
          }
        });

        if (hasError) {
          alert("Some items could not be removed. Please try again.");
          clearAllBtn.disabled = false;
          clearAllBtn.textContent = originalText;
          return;
        }

        // 触发购物车更新事件
        document.dispatchEvent(new CustomEvent("cart:build"));

        // 刷新页面
        window.location.reload();
      })
      .catch(function (error) {
        console.error("Clear cart error:", error);
        alert("Failed to clear cart. Please try again.");
        clearAllBtn.disabled = false;
        clearAllBtn.textContent = originalText;
      });
  });
}

/**
 * 多图商品手机端：Liquid 已输出 .sliver-product-media-nav__arrow，此处只绑定 Flickity
 */
function sliverGetProductFlickity(mainEl) {
  if (!mainEl) return null;
  if (typeof Flickity !== "undefined" && Flickity.data) {
    var f = Flickity.data(mainEl);
    if (f) return f;
  }
  return mainEl.flickity || null;
}

/**
 * 主题 childNavGoTo 用 offsetLeft 滚缩略图，在手机横向布局下经常不准；用视口几何对齐当前 is-active
 */
function sliverScrollActiveProductThumbIntoView(nav) {
  if (!nav || typeof window.matchMedia === "undefined") return;
  if (!window.matchMedia("(max-width: 768px)").matches) return;

  var scroller = nav.querySelector(".product__thumbs--scroller");
  var active = nav.querySelector(".product__thumb-item a.is-active");
  if (!scroller || !active) return;

  var item = active.closest(".product__thumb-item");
  if (!item) return;

  var sRect = scroller.getBoundingClientRect();
  var iRect = item.getBoundingClientRect();
  var itemCenter = iRect.left + iRect.width / 2;
  var scrollerCenter = sRect.left + scroller.clientWidth / 2;
  var delta = itemCenter - scrollerCenter;

  if (Math.abs(delta) < 2) return;

  scroller.scrollBy({ left: delta, behavior: "smooth" });
}

function sliverTryBindProductThumbScrollSync() {
  var navs = document.querySelectorAll(".sliver-product-media-nav--multi");
  for (var i = 0; i < navs.length; i++) {
    var nav = navs[i];
    if (nav.getAttribute("data-sliver-thumb-scroll") === "1") continue;

    var root = nav.closest("[data-product-images]");
    if (!root) continue;
    var mainEl = root.querySelector("[data-product-photos]");
    if (!mainEl || !mainEl.classList.contains("flickity-enabled")) continue;

    var flkty = sliverGetProductFlickity(mainEl);
    if (!flkty) continue;

    nav.setAttribute("data-sliver-thumb-scroll", "1");

    var onSlide = function () {
      requestAnimationFrame(function () {
        sliverScrollActiveProductThumbIntoView(nav);
      });
    };
    flkty.on("change", onSlide);
    onSlide();
  }
}

function sliverScheduleThumbScrollBind() {
  sliverTryBindProductThumbScrollSync();
  var n = 0;
  var id = setInterval(function () {
    sliverTryBindProductThumbScrollSync();
    if (++n > 32) clearInterval(id);
  }, 125);
}

document.addEventListener("DOMContentLoaded", sliverScheduleThumbScrollBind);
document.addEventListener("page:loaded", sliverScheduleThumbScrollBind);
document.addEventListener("shopify:section:load", function () {
  var reset = document.querySelectorAll(
    ".sliver-product-media-nav--multi[data-sliver-thumb-scroll]",
  );
  for (var r = 0; r < reset.length; r++) {
    reset[r].removeAttribute("data-sliver-thumb-scroll");
  }
  sliverScheduleThumbScrollBind();
});

document.addEventListener("click", function (e) {
  var btn = e.target.closest(
    ".sliver-product-media-nav__arrow--prev, .sliver-product-media-nav__arrow--next",
  );
  if (!btn) return;
  if (typeof window.matchMedia === "undefined") return;
  if (!window.matchMedia("(max-width: 768px)").matches) return;

  var nav = btn.closest(".sliver-product-media-nav--multi");
  if (!nav) return;

  var root = nav.closest("[data-product-images]");
  if (!root || root.getAttribute("data-has-slideshow") !== "true") return;

  var mainEl = root.querySelector("[data-product-photos]");
  var flkty = sliverGetProductFlickity(mainEl);
  if (!flkty) return;

  e.preventDefault();
  if (btn.classList.contains("sliver-product-media-nav__arrow--prev")) {
    flkty.previous();
  } else {
    flkty.next();
  }
});

function formatRelativeTime(dateString) {
  const now = new Date();
  const date = new Date(dateString);
  const diffInSeconds = Math.floor((now - date) / 1000);

  if (diffInSeconds < 60) {
    return diffInSeconds + "seconds";
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return diffInMinutes + "minutes";
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return diffInHours + "hours";
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) {
    return diffInDays + "days";
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) {
    return diffInMonths + "months";
  }

  const diffInYears = Math.floor(diffInMonths / 12);
  return diffInYears + "years";
}
